// extracted by mini-css-extract-plugin
export default {"input":"TextInputForm_input__SEfyO"};